import React, { useEffect } from 'react';
import useUser from '../../hooks/useUser';

const RazorpaySubscription = ({ subscriptionId }) => {
  const { user } = useUser();
  useEffect(() => {
    if (!subscriptionId) return;

    const loadRazorpay = async () => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => initializeRazorpay();
      document.body.appendChild(script);
    };

    const initializeRazorpay = async () => {
      try {
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY || "",
          subscription_id: subscriptionId,
          name: 'HolyPills',
          description: 'Subscription Payment',
          image: '/logo.png',
          handler: function (response) {
            console.log("Payment successful", response, process.env.REACT_APP_PAYMENT_SUCCESS);
            window.location.href = String(process.env.REACT_APP_PAYMENT_SUCCESS) || ""
          },
          prefill: {
            name: user?.name || '',
            email: user?.email || '',
            contact: user?.mobile ? `${user?.countryCode}${user?.mobile}` : ''
          },
          theme: {
            color: '#3399cc'
          }
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } catch (error) {
        console.error("Error loading Razorpay:", error);
      }
    };

    loadRazorpay();
  }, [subscriptionId]);

  return null; // UI not needed, it triggers Razorpay directly
};

export default RazorpaySubscription;
